<template>
  <router-view/>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  })
}
</script>

<style lang="scss">
html {
  font-size: 14px !important;
}

a {
  color: #9bbf33;
  text-decoration: none;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
}

.w-100 {
  width: 100%;
}

.sh-green {
  box-shadow: rgb(132 171 0 / 24%) 0px 8px 16px 0px !important
}

.v-btn {
  border-radius: 8px !important;

  &--round {
    border-radius: 50% !important;
  }
}

.v-text-field--outlined {
  border-radius: 8px !important;
  // border-color: rgba(145, 158, 171, 0.32) !important;
}

.container {
  padding: 24px !important;
}

.v-breadcrumbs {
  padding-left: 0 !important;

  &__item {
    color: rgb(33, 43, 54) !important;
    font-weight: 400;
  }

  &__item--disabled {
    font-weight: 400;
    color: rgb(145, 158, 171) !important;
  }
}

.v-pagination {
  &__item, &__navigation {
    box-shadow: rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 12%) 0px 12px 24px -4px !important;
  }
}

.tours-head {
  position: relative;

  .create-tour-btn {
    position: absolute;
    right: 0;
    top: 13px;
  }
}

.v-menu {
  &__content {
    box-shadow: rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) -20px 20px 40px -4px !important;

    .v-list {
      &-item {
        min-height: 34px !important;
        margin-bottom: 0 !important;
      }

      &-item__title {
        font-weight: 400 !important;
        font-size: 0.95rem !important;
        font-family: "Public Sans", sans-serif;
      }

      &-item__icon:first-child {
        margin-right: 4px !important;
      }

      &-item__icon {
        height: 24px;
        margin-top: 5px !important;
        margin-bottom: 5px !important;
      }

      .v-icon {
        font-size: 20px;
      }
    }
  }

  &--red, &--red .v-icon {
    color: rgb(255, 72, 66) !important;
  }
}

.v-pagination {
  justify-content: flex-start !important;
}

.us-n {
  user-select: none;
}
</style>
